import type { OfferUnion } from 'utils/isOfferType.ts';
import type { OfferImage } from 'service/image/model.ts';

export function isOfferImageValid(offer: OfferUnion) {
	if ('images' in offer) {
		return Boolean(offer.images?.length && (typeof offer.images[0] === 'string' || offer.images[0]?.url));
	} else {
		return Boolean(offer.image);
	}
}

function areImagesAsStrings(images: any[]): images is string[] {
	return typeof images[0] === 'string';
}

export function getOfferImages(offer?: OfferUnion): OfferImage[] | undefined {
	if (!offer) {
		return undefined;
	}

	if ('images' in offer && offer.images) {
		if (areImagesAsStrings(offer.images)) {
			return offer.images.map((image) => ({ url: image }));
		} else {
			return offer.images;
		}
	} else if ('image' in offer) {
		return [{ url: offer.image ?? '' }];
	}

	return undefined;
}
